import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=6d28ae8f&scoped=true&"
import script from "./MsgList.vue?vue&type=script&lang=js&"
export * from "./MsgList.vue?vue&type=script&lang=js&"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=6d28ae8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28ae8f",
  null
  
)

export default component.exports